import { render, staticRenderFns } from "./MarketCommoditiesView.vue?vue&type=template&id=4444ec64&scoped=true"
import script from "./MarketCommoditiesView.vue?vue&type=script&lang=js"
export * from "./MarketCommoditiesView.vue?vue&type=script&lang=js"
import style0 from "./MarketCommoditiesView.vue?vue&type=style&index=0&id=4444ec64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4444ec64",
  null
  
)

export default component.exports